import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {InterceptorGuard} from "@security/interceptor.guard";

const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('@pages/login/login.component').then((x) => x.LoginComponent),
  },
  {
    path: 'home',
    loadChildren: ()=> import('@pages/home/home.module').then(x => x.HomeModule),
    canActivate: [ InterceptorGuard]
  },
  {
    path: 'admin',
    loadChildren: ()=> import('@pages/users/users.module').then(x => x.UsersModule)
  },
  {
    path: 'users',
    loadChildren: ()=> import('@pages/users/users.module').then(x => x.UsersModule)
  },
  {
    path: '**',
    redirectTo: 'login'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
